import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import style from '../../../../scss/components/form.module.scss';
import Field from './Field';

const TagTypeCheckboxFilter = ({
    entity,
    onChange,
    service,
    name,
    endpoint,
    className,
    ...props
}) => {
    const [types, setTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    let selectedTypes;
    if (Array.isArray(entity[name])) {
        selectedTypes = entity[name];
    } else {
        selectedTypes = entity[name] ? [entity[name]] : [];
    }

    useEffect(() => {
        let cancelled = false;

        setIsLoading(true);

        service
            .get(endpoint)
            .then((result) => {
                if (cancelled) {
                    return;
                }

                const data = Array.isArray(result)
                    ? result
                    : result?.data ?? [];

                setTypes(data.filter(Boolean));
            })
            .catch(() => {
                if (!cancelled) {
                    setTypes([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [service, endpoint]);

    const toggleType = (type) => {
        const nextSelectedTypes = selectedTypes.includes(type)
            ? selectedTypes.filter((item) => item !== type)
            : [...selectedTypes, type];

        onChange({
            [name]: nextSelectedTypes,
        });
    };

    return (
        <div className={classNames(style.formGroup, className)}>
            <Field {...props} name={name}>
                {(hasError, attributes) => (
                    <div
                        id={attributes.id}
                        className={classNames(style.checkboxGroup, {
                            [style.isInvalid]: hasError,
                        })}
                    >
                        {isLoading && <span>Loading...</span>}

                        {!isLoading &&
                            types.map((type) => (
                                <label
                                    key={type}
                                    className={style.checkboxLabel}
                                >
                                    <input
                                        type="checkbox"
                                        name={`${name}[]`}
                                        value={type}
                                        checked={selectedTypes.includes(type)}
                                        onChange={() => toggleType(type)}
                                    />

                                    <span>{type}</span>
                                </label>
                            ))}
                    </div>
                )}
            </Field>
        </div>
    );
};

TagTypeCheckboxFilter.propTypes = {
    entity: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    service: PropTypes.object.isRequired,
    name: PropTypes.string,
    endpoint: PropTypes.string,
    className: PropTypes.string,
};

TagTypeCheckboxFilter.defaultProps = {
    name: 'types',
    endpoint: 'tags/types',
    className: '',
};

export default TagTypeCheckboxFilter;
